import { render, staticRenderFns } from "./electricitySharing.vue?vue&type=template&id=68c2035a&scoped=true"
import script from "./electricitySharing.vue?vue&type=script&lang=js"
export * from "./electricitySharing.vue?vue&type=script&lang=js"
import style0 from "./electricitySharing.vue?vue&type=style&index=0&id=68c2035a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c2035a",
  null
  
)

export default component.exports